<template>
  <v-container class="mt-0" fluid>
    <v-row>
      <v-col col="12" class="text-right">
        <v-btn
            right
            class="mr-4 button-new-order"
            rounded
            color="#dffac2"
            @click.prevent="searchOrderModalShow"
            :disabled="!shiftData.id"
        >
          Поиск заказа
        </v-btn>
        <v-btn
          right
          class="mr-4 button-new-order"
          rounded
          color="#dffac2"
          @click.prevent="fastOrder()"
          :disabled="!shiftData.id"
        >
          Быстрый заказ
        </v-btn>
        <v-btn
            right
            class="mr-4 button-new-order"
            rounded
            data-test-id="newOrderButton"
            color="#dffac2"
            to="/order/new"
            :disabled="!shiftData.id"
        >
          Новый заказ
        </v-btn>
      </v-col>
    </v-row>
    <v-row :class="{ 'd-none': displayNone }">
      <v-col class="col-md-3">
        <div class="card-block pt-0 pending pb-3">
          <div
              class="
              block-header
              d-flex
              align-items-center
              justify-content-between
              py-2
              px-1
              mb-3
            "
          >
            <div class="col mob-100">
              <h4 class="m-0">По записи</h4>
            </div>
          </div>
          <div>
            <div class="block-body row pt-3">
              <v-progress-linear
                  v-if="loadInWork"
                  color="green accent-4"
                  indeterminate
                  rounded
                  height="6"
                  class="ma-4"
              ></v-progress-linear>
              <template >
                <div v-for="(item, index) in pending"
                     class="zero-padding col-12 card-pointer pa-2"
                     :key="item.id"
                     @click="$router.push('/order/' + item.id)"
                >
                  <OrderCard
                      :key="'pending-' + index"
                      :id="item.id"
                      :car-name="item.car_mark + ' ' + item.car_model"
                      :price="item.sum"
                      :index="index"
                      :started-at="item.time.started_at || item.start"
                      :booking-start-time="item.time.booking_start_time"
                      :has-long-time-services="item.has_long_time_services"
                      :params="item.params"
                      :real-date="realDate"
                      :finished-at="item.time.finished_at"
                      :shouldBeFinishedAt="item.time.should_be_finished_at"
                      :type="'pending'"
                  />
                </div>
              </template>
            </div>
          </div>
        </div>
        <div style="height: 16px;"></div>
        <div class="card-block queued-new bg-gray pb-3 position-relative">
          <div
            class="
              block-header
              gray-title
              d-flex
              align-items-center
              justify-content-between
              pt-2
              px-1
              mb-1
            "
          >
            <div class="col mob-100">
              <h3 class="m-0">Заказы в очереди</h3>
            </div>
          </div>
          <!-- БЛОК Заказы в очереди -->
          <div class="block-body">
            <template v-for="(item, index) in queue">
              <div
                class="zero-padding mb-1 bottom-border divider-text col-12"
                v-if="item.date"
                :key="'que-' + index"
              >
                {{ dayLayout(item.started_at) }}
              </div>
              <OrderCard
                v-else
                :key="'queon-' + index"
                :started-at="item.started_at"
                :car-name="item.vehicle.name"
                :customer-name="item.customer.name"
                :duration="item.duration"
                :discount="item.discount.value"
                :phone="item.customer.phone"
                :contract-number="item.contract_number"
                :delivered="item.delivered"
                :id="item.id"
                :storage-agreement="item.storage_agreement"
                :index="index"
                @click.native.prevent="createOrder(item)"
                @showDelInfo="showDelInfo"
              />
            </template>
          </div>
          <!-- БЛОК Заказы в очереди -->
        </div>
      </v-col>
      <v-col class="col-md-6">
        <div class="card-block pt-0 ongoing pb-3">
          <div
            class="
              block-header
              d-flex
              align-items-center
              justify-content-between
              py-2
              px-1
              mb-3
            "
          >
            <div class="col mob-100">
              <h4 class="m-0">В работе</h4>
            </div>
          </div>
          <div>
            <div class="block-body row pt-3">
              <!--                <router-link-->
              <!--                    :to="'/order/' + item.id"-->
              <!--                    tag="div"-->
              <!--                    class="zero-padding col-6 card-pointer"-->
              <!--                    v-for="item in inWork"-->
              <!--                    :key="item.id"-->
              <!--                >-->
              <v-progress-linear
                v-if="loadInWork"
                color="green accent-4"
                indeterminate
                rounded
                height="6"
                class="ma-4"
              ></v-progress-linear>
              <template >
                <div v-for="(item, index) in inWork"
                  class="zero-padding col-6 card-pointer pa-2"
                  :key="item.id"
                  @click="$router.push('/order/' + item.id)"
                >
                  <OrderCard
                    :key="'inWork-' + index"
                    :id="item.id"
                    :car-name="item.car_mark + ' ' + item.car_model"
                    :price="item.sum"
                    :index="index"
                    :booking-start-time="item.time.booking_start_time"
                    :started-at="item.time.started_at || item.start"
                    :real-date="realDate"
                    :finished-at="item.time.finished_at"
                    :has-long-time-services="item.has_long_time_services"
                    :params="item.params"
                    :shouldBeFinishedAt="item.time.should_be_finished_at"
                    :type="'inWork'"
                  />
                  <!--                  :started-at="item.started_at"-->
                  <!--                  :car-name="item.name"-->
                  <!--                  :customer-name="item.customer.name"-->
                  <!--                  :duration="item.duration"-->
                  <!--                  :discount="item.discount.value"-->
                  <!--                  :phone="item.customer.phone"-->
                  <!--                  :contract-number="item.contract_number"-->
                  <!--                  :delivered="item.delivered"-->
                  <!--                  :storage-agreement="item.storage_agreement"-->
                  <!--                  <order-slot :infotext="item" :real-date="realDate" />-->
                </div>
              </template>
              <!--                </router-link>-->
              <!--div class="card-bloch-footer mt-2">
                  <button class="btn add-block w-100" @click="addOrder">+ Добавить заказ</button>
              </div-->
            </div>
          </div>
        </div>
      </v-col>
      <v-col class="col-md-3">
        <div class="card-block accomplished pb-3">
          <div
            class="
              block-header
              done-title
              d-flex
              align-items-center
              justify-content-between
              py-2
              px-1
              mb-2
            "
          >
            <div class="col mob-100">
              <h3 class="m-0">Выполненные</h3>
            </div>
          </div>
          <div class="block-body row pa-3">
            <router-link
              v-for="(item, index) in workDone"
              :key="item.id"
              tag="div"
              class="
                record-margin
                zero-padding
                ma-1
                col
                inwork-card
                card-pointer
              "
              :to="'/order/' + item.id"
            >
              <!--              <order-slot-->
              <!--                :infotext="item"-->
              <!--                @click="$router.push('/order/' + item.id)"-->
              <!--              />-->
              <OrderCard
                :key="'isEnd-' + index"
                :id="item.id"
                :car-name="item.car_mark + ' ' + item.car_model"
                :price="item.sum"
                :index="index"
                :booking-start-time="item.time.booking_start_time"
                :started-at="item.time.started_at || item.start"
                :real-date="realDate"
                :finished-at="item.time.finished_at"
                :has-long-time-services="item.has_long_time_services"
                :params="item.params"
                :type="'isEnd'"
                :shouldBeFinishedAt="item.time.should_be_finished_at"
              />
              <!--              :started-at="item.started_at"-->
              <!--              :car-name="item.vehicle.name"-->
              <!--              :customer-name="item.customer.name"-->
              <!--              :duration="item.duration"-->
              <!--              :discount="item.discount.value"-->
              <!--              :phone="item.customer.phone"-->
              <!--              :contract-number="item.contract_number"-->
              <!--              :delivered="item.delivered"-->
              <!--              :id="item.id"-->
              <!--              :storage-agreement="item.storage_agreement"-->
            </router-link>
          </div>
        </div>
      </v-col>
    </v-row>
    <modal name="searchOrderModal" width="50%">
      <div class="card-body text-center">
        <h3>Поиск заказа по номеру сохранной расписки</h3>
        <div class="form-inline d-block text-center">
          <label class="my-1 mr-2" for="order">Номер сохранной расписки:</label>
          <input
            id="order"
            v-model="searchOrder"
            name="order"
            class="form-control m-2"
            :class="{ 'is-invalid': showSearchSafetyReceiptError }"
            type="text"
            @keydown.enter="openSafetyReceiptOrder"
            placeholder="12345"
          />
          <button
            class="btn btn-success"
            @click.prevent="openSafetyReceiptOrder"
          >
            В работу
          </button>
          <div class="invalid-feedback" v-if="showSearchSafetyReceiptError">
            Введен неверный номер сохранной расписки
          </div>
        </div>
        <button
          class="mt-16 btn btn-outline-success"
          @click.prevent="searchOrderModalHide()"
        >
          Закрыть
        </button>
      </div>
    </modal>
    <v-dialog v-model="deliveryCompletedDialog" max-width="790">
      <v-card>
        <v-card-title class="headline">{{ info.title }}</v-card-title>

        <v-card-text v-if="info.description">
          {{ info.description }}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="warning"
            @click="deliveryCompletedDialog = false"
            style="color: white; border-radius: 0.125rem"
          >
            закрыть
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="success"
            @click="deliveryCompleted()"
            style="color: white; border-radius: 0.125rem"
          >
            подтвердить
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deliveryOKDialog" width="390">
      <v-card>
        <v-card-title class="headline text-center">
          колеса доставлены!
        </v-card-title>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="#00c851"
            @click="deliveryOKDialog = false"
            style="color: white; border-radius: 0.125rem"
          >
            закрыть
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--    <v-footer app bottom fixed padless>-->
    <!--      <v-col class="text-center" cols="12">-->
    <!--        Сеть мастерских Две атмосферы - -->
    <!--        {{ workshop.address }}-->
    <!--      </v-col>-->
    <!--    </v-footer>-->
  </v-container>
</template>

<script>
import axios from "../plugins/axios-common";
import { mapGetters } from "vuex";
import OrderCard from "../components/order/OrderCard.vue";

export default {
  name: "CashHome",
  components: {
    OrderCard,
    // orderSlot: () => import("../components/mainpage/orderSlot.vue"),
    // currentTime: () => import('./components/cashbox/mainpage/CurrentTime.vue'),
    // motivation: () => import('./components/cashbox/mainpage/Motivation.vue'),
    // master: () => import('./components/cashbox/mainpage/Master.vue'),
    // menuDropdown: () => import('./components/cashbox/mainpage/MenuDropdown.vue'),
    // queueOrder: () => import('./components/cashbox/mainpage/QueueOrder.vue'),
    // order: () => import('./components/cashbox/mainpage/Order.vue'),
    // timeline: () => import('./components/cashbox/mainpage/Timeline.vue'),
    // errorFlashMessage: () => import('./components/cashbox/mainpage/ErrorFlashMessage.vue'),
  },
  data() {
    return {
      realDate: null,
      loadInWork: true,
      deliveryCompletedDialog: false,
      deliveryOKDialog: false,
      info: {
        title: "",
        description: "",
        contract_number: "",
        phone: "",
        id: "",
        index: null,
      },
      queue: [],
      pending: [],
      inWork: [], // в работе
      deferred: [], // отложеные
      workDone: [], // готовые
      ordersList: {},
      orders: {},
      searchOrder: "",
      showSearchSafetyReceiptError: false,
    };
  },
  mounted() {
    //reset all data for jumping between orders from cashhome
    this.getRealDate();
    this.$store.commit("resetClient");
    this.$store.commit("resetCarData");
    this.$store.commit("resetChoosenServicesComponent");
    this.$store.dispatch("login/getWorkshop");
    let today = new Date();
    let curr_date = today.getDate();
    curr_date =
      curr_date < 10 ? "0" + curr_date.toString() : curr_date.toString();
    let curr_month = today.getMonth() + 1;
    curr_month =
      curr_month < 10 ? "0" + curr_month.toString() : curr_month.toString();
    const curr_year = today.getFullYear();
    today = curr_year + "-" + curr_month + "-" + curr_date;
    //console.log('date', today)
    this.$store.dispatch("shift/fetchShiftDataAxios").then((resp) => {
      if (!this.shiftData.opened) {
        this.$router.push("/shift");
      }
      this.$store.dispatch("shift/fetchShiftOrders", resp.id).then((orders) => {
        // if (orders.data.recomendation && orders.data.recomendation.length>0) this.deferred = this.deferred.concat(orders.data.recomendation)
        if (orders.data.ready && orders.data.ready.length > 0)
          this.workDone = this.workDone.concat(orders.data.ready);
        if (orders.data.paymentpending && orders.data.paymentpending.length > 0)
          this.workDone = this.workDone.concat(orders.data.paymentpending);
        if (orders.data.inprogress && orders.data.inprogress.length > 0)
          this.inWork = this.inWork.concat(orders.data.inprogress);
        if (orders.data.pending && orders.data.pending.length > 0)
          this.pending = this.pending.concat(orders.data.pending);
        this.loadInWork = false;
      });
      if (resp.shiftinfo?.basic.workshop_id) {
        axios
          .get(
            "/api/cash/queue?workshop_id=" +
              resp.shiftinfo.basic.workshop_id +
              "&date=" +
              today
          )
          .then(res => (this.queue = res.data))
          /*.then((queue) => {
 console.log('в очереди',queue.data)
            if (queue.data.length > 0) {
              let filtered = [];
              let nowDay = "";
              queue.data.forEach((x) => {
                if (x.customer && x.customer.phone) {
                  // x.storage_agreement.is_tires_on_base = 0
                  let tempStartDate = new Date(x.started_at);
                  tempStartDate.setHours(0, 0, 0, 0);
                  if (nowDay < tempStartDate) {
                    nowDay = tempStartDate;
                    filtered.push({
                      started_at: tempStartDate,
                      date: true,
                    });
                  }
                  filtered.push(x);
                }
              });
              filtered.sort((a, b) => {
                let comparison = 0;
                if (a.started_at > b.started_at) {
                  comparison = 1;
                } else if (a.started_at < b.started_at) {
                  comparison = -1;
                } else if (a.started_at === b.started_at) {
                  if (a.started_at > b.started_at) {
                    comparison = 1;
                  } else if (a.started_at < b.started_at) {
                    comparison = -1;
                  }
                }
                return comparison;
              });
              this.queue = filtered;
              
  console.log('in queue',queue.data);
            }
            
          });*/
      }
      console.log('в очереди',this.queue)
    });
    this.$store.dispatch("fetchPromocodes");
  },
  methods: {
    pnicenr () {
      axios
          .post("/api/cash/sendcheckemployeespresence")
    },
    fastOrder() {
      this.$store.commit('resetClient')
      this.$store.commit('resetChoosenServicesComponent')
      this.$store.commit('anonymousClient')
      this.$store.commit('login/setChosenDirection', 'additional')
      this.$router.push('/order/chooseservices')
    },
    // todo сделать линк на тип -> картинка понять что линковать
    carTypeIco(id) {
      switch (id) {
        case "Легковые":
          return "images/sedan.png";
        case "Кроссоверы":
          return "images/jeep.png";
        case "Минивены":
          return "images/gazel.png";
        default:
          return "";
      }
    },
    getRealDate() {
      this.realDate = null;
      this.$nextTick(() => {
        this.realDate = new Date();
      });
      setTimeout(() => this.getRealDate(), 1000);
    },
    dayLayout(d) {
      let day = d.getDate();
      let month = d.getMonth();
      let year = d.getFullYear();
      day = day < 10 ? "0" + day.toString() : day.toString();
      month = month < 10 ? "0" + month.toString() : month.toString();
      return day + "-" + month + "-" + year;
    },
    showDelInfo([id, contrNumber, phone, index]) {
      this.info.title = "Доставка шин по контракту " + contrNumber;
      this.info.description = "Подтвердите доставку колес на место выдачи";
      this.info.contract_number = contrNumber;
      this.info.phone = phone;
      this.info.id = id;
      this.info.index = index;
      this.deliveryCompletedDialog = true;
    },
    deliveryCompleted() {
      // todo запрос к api
      console.log("api send deliver OK contract number and id", {
        cn: this.info.contract_number,
        id: this.info.id,
      });

      axios
        .post("/api/cash/seasonalstorage/delivered", {
          cn: this.info.contract_number,
          id: this.info.id,
          phone_number: this.info.phone.replace(/[^0-9.]/g, ""),
        })
        .then(() => {
          this.queue[this.info.index].storage_agreement.is_tires_on_base = 1;
          this.queue[this.info.index].delivered = 1;
          this.deliveryCompletedDialog = false;
          this.deliveryOKDialog = true;
        });
    },
    startTime(date) {
      const tdate = new Date(date);
      let h = tdate.getHours();
      h = h < 10 ? "0" + h.toString() : h.toString();
      let m = tdate.getMinutes();
      m = m < 10 ? "0" + m.toString() : m.toString();
      return h + ":" + m;
    },
    addOrder() {
      window.location.href = "new";
    },
    notify(quote, type) {
      this.$store.dispatch("sendNotification", {
        quote: quote,
        type: type,
      });
    },
    createOrder(item) {
console.log('hit createOrder', item.customer.phone);
      let phone = item.customer.phone.replace(/[^0-9.]/g, "");
      if (item.discount.card_number && Array.isArray(this.promocodes)) {
        var promocode = this.promocodes?.find(
          (obj) => obj.code === item.discount.card_number.toUpperCase()
        );
      }
      Promise.all([
        this.$store.dispatch("fetchClient", {
          searchString: phone,
          type: "phone",
        }),
      ]).finally(() => {
        if (this.client.discount.card_number) {
console.log(this.client.discount.card_number);
          this.$store.commit("updateQueueId", item.id);
console.log(promocode);
if (promocode) {
  this.$store.commit("updateChosenPromocode", promocode);
}  
          //
          this.$router.push("/order/clientcard");
        } else {
          this.client.customer.name = item.customer.name;
          this.client.customer.phone = phone;
          this.$store.commit("updateQueueId", item.id);
console.log(promocode);
if (promocode) {
  this.$store.commit("updateChosenPromocode", promocode);
}
          this.$store.commit("updateCardNumber", this.getRandomInt());
          this.$router.push("/newclient/from-queue");
        }
      });
    },
    getRandomInt() {
      let min = Math.ceil(5000000);
      let max = Math.floor(5999999);
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    searchOrderModalShow() {
      this.$modal.show("searchOrderModal");
    },
    searchOrderModalHide() {
      this.searchOrder = "";
      this.showSearchSafetyReceiptError = false;
      this.$modal.hide("searchOrderModal");
    },
    openSafetyReceiptOrder() {
      // self = this;
      axios
        .post("/api/cash/safetyreceipts", {
          orderId: this.searchOrder,
          shiftId: this.shiftData.id,
        })
        .then((res) => {
          this.$router.push("/order/" + res.data.orderId);
        })
        .catch(function (error) {
          this.showSearchSafetyReceiptError = true;
          console.log(error);
        });
    },
  },
  computed: {
    ...mapGetters([
      "kkmData",
      "kkmSell",
      "kkmShiftStatus",
      "promocodes",
      "displayNone",
    ]),
    ...mapGetters("shift", ["shiftData"]),
    // workshop() {
    //   return this.$store.state.login.workshop;
    // },
    client: {
      get() {
        return this.$store.getters.client;
      },
      set(value) {
        this.$store.commit("updateClient", value);
      },
    },
  },
  watch: {
    kkmSell() {
      if (this.kkmSell.errorCode > 0) {
        console.log("ErrorCode:" + this.kkmSell.errorCode);
        this.notify(this.kkmSell.errorDescription, "danger");
      }
    },
    kkmData() {
      // console.log(this.kkmData.errorCode)
      if (this.kkmData.errorCode > 0) {
        console.log("ErrorCode:" + this.kkmData.errorCode);
        this.notify(this.kkmData.errorDescription, "danger");
      }
      if (this.kkmData.errorCode == 68) {
        console.log("ErrorCode:" + this.kkmData.errorCode);
        this.notify(this.kkmData.errorDescription, "danger");
        this.$store.dispatch("closeKKMShift", this.shiftData);
        this.notify("Закрываем смену", "success");
        setTimeout(() => {
          this.notify("Открываем новую смену", "success");
          this.$store.dispatch("openKKMShift");
        }, 8000);
      }
    },
  },
};
</script>

<style>
/* styles for all orderSlots */
.hh-text {
  font-size: 24px;
}
.mm-text {
  font-size: 24px;
}
.ss-text {
  font-size: 20px;
  padding-left: 3px;
}
/* styles for all orderSlots */

.inwork-card {
  /*max-width: 300px;*/
  min-width: 250px;
}
.mark-logo {
  max-width: 30px;
  max-height: 30px;
}
.card-pointer {
  cursor: pointer;
}
.divider-text {
  font-size: large;
}
.bottom-border {
  border-bottom: 1px solid darkgray;
}
.row .middle-container {
  height: 45px;
}
.card-block .gray-title {
  background: #d0cfcf;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.5);
  margin: 0 -15px;
  padding: 0 !important;
}
.card-block .gray-title h3 {
  font-weight: bold;
  font-size: 20px;
  color: #000000;
}
.card-block .done-title h3 {
  font-weight: bold;
  font-size: 20px;
  color: #000000;
}
.card-block .done-title {
  background: #ecf1ae;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.5);
  margin: 0 -15px;
  padding: 0 !important;
}
.card-block .block-body {
  position: relative;
  overflow-x: visible;
  overflow-y: auto;
  max-height: 570px;
  height: 100%;
  z-index: 1;
  margin: 0 -15px;
  padding: 0 15px;
}
.box-shaddow {
  box-shadow: 1px 1px 4px #988787;
}
.deliver-status {
  position: absolute;
  right: 4px;
  bottom: 4px;
}
.price-container {
  /* height: 100%; */
  display: flex;
  justify-content: space-between !important;
  align-items: flex-end;
  flex-direction: column;
  align-content: space-around;
  position: absolute;
  right: 4px;
  top: 4px;
}
.card-block {
  font-family: "Istok Web", sans-serif;
  font-size: 14px;
  min-height: 250px;
  max-height: 640px;
  overflow-y: hidden;
  overflow-x: visible;
  color: #000000;
}
.car-record-text {
  font-weight: normal !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 170px;
  height: 20px;
}
.block-body::-webkit-scrollbar {
  width: 5px;
}
.block-body::-webkit-scrollbar-thumb {
  background: #919191;
}
.block-body::-webkit-scrollbar-track {
  background: #d3d3d3;
}
</style>
